import type { Brand } from '@seek/melways-sites';
const defaultDisplayBrand = 'SEEK';

const displayBrands: Record<string, string> = {
  seek: 'SEEK',
  jobsdb: 'Jobsdb',
  jobstreet: 'Jobstreet',
};

export default (brand: Brand = 'seek'): string =>
  displayBrands[brand] || defaultDisplayBrand;
